import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { ContactType, contactTypes } from '@/domain/ecommerce-contact'
import { contactTypeLabelKey } from './contact-types'

const { SelectCombobox } = Base

interface ContactTypesSelectProps {
  value: ContactType[]
  onChange: (types: ContactType[]) => void
  disabledTypes?: ContactType[]
  disabled?: boolean
  placeholder?: string
  ariaLabel?: string
  required?: boolean
}

export const ContactTypesSelect: React.FC<ContactTypesSelectProps> = ({
  value,
  onChange,
  disabledTypes = [],
  disabled,
  placeholder,
  ariaLabel,
  required
}) => {
  const { t } = useTranslation()

  return (
    <SelectCombobox<ContactType>
      multiple
      items={contactTypes}
      value={value}
      // Kept in the dashboard order whatever order they were picked in.
      onChange={(next) =>
        onChange(contactTypes.filter((type) => next.includes(type)))
      }
      itemLabel={(type) => t(contactTypeLabelKey(type))}
      // A role already picked stays enabled so it can be removed.
      isItemDisabled={(type) =>
        disabledTypes.includes(type) && !value.includes(type)
      }
      disabled={disabled}
      placeholder={placeholder ?? t('dashboard_users.select_point_of_contact')}
      ariaLabel={ariaLabel ?? t('dashboard_users.point_of_contact_label')}
      triggerLabel={t('dashboard_users.select_point_of_contact')}
      required={required}
    />
  )
}
